import React from "react";
import Tippy from "@tippy.js/react";
import TooltipText from "../../../TooltipText/TooltipText";

// import { ReactComponent as IconDelete } from "../../../../build/images/select-search-with-pagination/icon-delete.svg";
import { ReactComponent as IconDelete } from "../../../../build/mui-mult-select-assets/close-circle.svg";

const Tags = ({
  limitTags,
  selectedOptions,
  getOptionKey,
  onClickOption,
  disabled = false,
}) => {
  const limit = limitTags === -1 ? selectedOptions.length : limitTags;
  const visible = selectedOptions.slice(0, limit);
  const hidden = selectedOptions.slice(limit);

  // Quando uma tag é removida de dentro do tooltip, o conteúdo encolhe e o Tippy
  // dispara um "hide" indesejado. Esse flag cancela exatamente esse hide,
  // mantendo o tooltip aberto, sem impedir o fechamento normal ao sair com o mouse.
  const skipNextHideRef = React.useRef(false);

  return (
    <>
      {visible.map((opt) => (
        <span
          key={`select-search-chip-${getOptionKey(opt)}`}
          className="select-search-btn__chip"
        >
          <Tippy interactive theme="light" content={TooltipText([opt])}>
            <span className="select-search-btn__chip-label">
              {opt.label ? opt.label : opt.nome}
            </span>
            <span
              className="select-search-btn__chip-remove"
              onClick={(e) => {
                if (disabled) return;
                e.stopPropagation();
                onClickOption(opt);
              }}
            >
              <IconDelete />
            </span>
          </Tippy>
        </span>
      ))}
      {hidden.length > 0 && (
        <Tippy
          hideOnClick={false}
          interactive
          interactiveBorder={16}
          theme="light"
          onHide={() => {
            if (skipNextHideRef.current) {
              skipNextHideRef.current = false;
              return false; // cancela o hide indesejado após remover uma tag
            }
            return true;
          }}
          content={TooltipText(
            hidden.map((opt) => ({
              id: getOptionKey(opt),
              label: opt.label ? opt.label : opt.nome,
            })),
            (item) => {
              skipNextHideRef.current = true;
              // failsafe: se nenhum hide for disparado, libera o próximo fechamento
              setTimeout(() => {
                skipNextHideRef.current = false;
              }, 250);
              if (disabled) return;
              onClickOption(item);
            },
            disabled,
          )}
        >
          <span
            className="select-search-btn__chip-extra"
            onClick={(e) => e.stopPropagation()}
          >
            +{hidden.length}
          </span>
        </Tippy>
      )}
    </>
  );
};

export default Tags;
